module.exports = __webpack_public_path__ + "img/other_other.3f759419.png";